import { use, useMemo } from 'react';
import RowItem from 'shared/components/table/types/row-item';

import Resident from 'features/residents/models/resident';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';

type ResidentSettingsTable = {
  tableData: RowItem<Resident>[];
  currentItem?: Resident;
  selectedRows?: RowItem<Resident>[];
};

const useResidentSettingsTable = (): ResidentSettingsTable => {
  const {
    residentSettings,
    detailEditState: { currentResidentSetting },
    bulkEditState: { selectedResidentSettings },
  } = use(ResidentSettingsProviderContext);

  return {
    tableData: useMemo(
      () =>
        residentSettings
          ? residentSettings.residents.map<RowItem<Resident>>((resident) => ({ data: resident, isFaded: resident.scenariosMuted }))
          : [],
      [residentSettings],
    ),
    currentItem: useMemo(
      () => residentSettings?.residents.find((resident) => resident.organisationUnitId === currentResidentSetting?.organisationUnitId),
      [residentSettings, currentResidentSetting],
    ),
    selectedRows: useMemo(
      () => selectedResidentSettings?.map<RowItem<Resident>>((resident) => ({ data: resident, isFaded: resident.scenariosMuted })),
      [selectedResidentSettings],
    ),
  };
};

export default useResidentSettingsTable;
